/*
 * @Author: xinxinfeng 2273234784@qq.com
 * @Date: 2025-05-21 10:41:18
 * @LastEditors: xinxinfeng 2273234784@qq.com
 * @LastEditTime: 2026-07-24 15:27:10
 * @FilePath: \crane-safety-manager\src\Routes\allRoutes.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { Navigate } from 'react-router-dom';

import Signin from '../pages/Authentication/login';
import Logout from '../pages/Authentication/logout';
import UserProfile from '../pages/Authentication/user-profile';
import Register from '../pages/Authentication/register';
import Forgetpassword from '../pages/Authentication/forgetpassword';
// import DashboardProjects from '../pages/Dashboard/Projects';
import DashboardVehicles from '../pages/Dashboard/Vehicles';

import ProjectList from '../pages/ProjectList';
import SiteList from '../pages/SiteList';
import UserList from '../pages/UserList';
import VehicleList from '../pages/VehicleList';
import VehicleProfile from '../components/VehicleProfile/VehicleProfile';
import AlarmLogList from '../pages/AlarmLogList';
import PoleList from '../pages/PoleList';

const authProtectedRoutes = [
    { path: '/dashboard/vehicles', component: <DashboardVehicles /> },
    // { path: '/dashboard/projects', component: <DashboardProjects /> },
    { path: '/projects', component: <ProjectList /> },
    { path: '/sites', component: <SiteList /> },
    { path: '/users', component: <UserList /> },
    { path: '/vehicles', component: <VehicleList /> },
    { path: '/vehicles/:vehicleId', component: <VehicleProfile /> },
    { path: '/alarm-logs', component: <AlarmLogList /> },
    { path: '/poles', component: <PoleList /> },
    { path: '/user-profile', component: <UserProfile /> },
    { path: '/', exact: true, component: <Navigate to="/dashboard/vehicles" /> },
    { path: '*', component: <Navigate to="/dashboard/vehicles" /> }
];

const publicRoutes = [
    // Authentication
    { path: '/login', component: <Signin /> },
    { path: '/logout', component: <Logout /> },
    { path: '/register', component: <Register /> },
    { path: '/forgot-password', component: <Forgetpassword /> }
];

export { publicRoutes, authProtectedRoutes };
